const loadActionTypes = {
  SET_LOADS_LIST: "SET_LOADS_LIST",
  SET_ALL_LOADS_NUMBER: "SET_ALL_LOADS_NUMBER",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_LOADS_LIST_IS_LOADING: "SET_LOADS_LIST_IS_LOADING",
  SET_REQ_INFO_IS_LOADING: "SET_REQ_INFO_IS_LOADING",
  //
  SET_CURRENT_LOAD: "SET_CURRENT_LOAD",
  SET_LOAD_BITS: "SET_LOAD_BITS",
};

export default loadActionTypes;
